export default __webpack_public_path__ + "advantage-49e2b43.png";